import PrestigeIcon from "assets/svg/package_prestige.svg";
import PrestigePlusIcon from "assets/svg/package_prestige_plus.svg";
import PlatinumIcon from "assets/svg/package_platinum.svg";
import PlatinumPlusIcon from "assets/svg/package_platinum_plus.svg";
import PlatinumBlackIcon from "assets/svg/package_platinum_black.svg";
import PlatinumPlusBlackIcon from "assets/svg/package_platinum_plus_black.svg";

export const accountTypes = {
  prestige: <PrestigeIcon />,
  "prestige plus": <PrestigePlusIcon />,
  platinum: <PlatinumIcon />,
  "platinum plus": <PlatinumPlusIcon />,
  premium: "PREMIUM",
  platinum_black: <PlatinumBlackIcon />,
  platinum_plus_black: <PlatinumPlusBlackIcon />,
};
